import { TreePine } from 'lucide-react';
import { GARDEN_STYLES } from '../lib/gardenDesignOptions';

/**
 * @typedef {{ id: string; label: string; image: string | null; Icon?: typeof TreePine }} GardenDesignStyle
 */

/** @type {GardenDesignStyle[]} */
export const GARDEN_DESIGN_STYLES = GARDEN_STYLES.map((label) => ({
  id: label
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-|-$/g, ''),
  label,
  image: null,
  Icon: TreePine,
}));

/**
 * @param {string} label
 * @returns {GardenDesignStyle | undefined}
 */
export function findGardenStyleByLabel(label) {
  return GARDEN_DESIGN_STYLES.find((style) => style.label === label);
}
